const VOLUME_KEY = 'stimulus_volume';

export const loadVolume = (): number => {
  const stored = localStorage.getItem(VOLUME_KEY);
  return stored !== null ? parseFloat(stored) : 1;
};

export const persistVolume = (volume: number): void => {
  localStorage.setItem(VOLUME_KEY, String(volume));
};
